<template>
  <b-form-group label="Heures" label-class="label-style">
    <b-form-row>
      <label class="col-form-label">{{ $t('filter.time_between') }}</label>
      <b-col>
        <multiselect v-model="selectedStartValue" track-by="order" label="label" :options="optionsStart"
          :show-labels="false" :hide-selected="false" :close-on-select="true" :allow-empty="false" placeholder="" />
      </b-col>
      <label class="col-form-label">{{ $t('filter.time_between_and') }}</label>
      <b-col>
        <multiselect v-model="selectedEndValue" track-by="order" label="label" :options="optionsEnd"
          :show-labels="false" :hide-selected="false" :close-on-select="true" :allow-empty="false" placeholder="" />
      </b-col>
    </b-form-row>
  </b-form-group>
</template>

<script>
import { mapState } from "vuex";
import dimensionEnum from "@/model/dimensionEnum";
import { numberFormat } from "@/filter/numberFormat";
import Tools from "@/utils/tools";

export default {
  name: "TimeRangePicker",
  props: {
    useDefaultValue: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  data: function () {
    return {
      options: [],
      selectedStartValue: null,
      selectedEndValue: null,
      timeRangeFilter: null,
      isFullRange: false,
      storageKey: "TimeRangePicker",
    };
  },
  computed: mapState({
    optionsStart() {
      var self = this;
      return self.options.slice(0, self.options.length - 1);
    },
    optionsEnd() {
      var self = this;
      return self.selectedStartValue
        ? this.options.filter(
          (opt) => opt.order > self.selectedStartValue.order
        )
        : this.options;
    },
  }),
  watch: {
    selectedStartValue() {
      if (
        this.selectedStartValue &&
        this.selectedEndValue &&
        this.selectedStartValue.order >= this.selectedEndValue.order
      ) {
        // La nouvelle heure de début n'est plus cohérente avec la fin, on remet une valeur par défaut à la fin
        this.selectedEndValue = this.optionsEnd[0];
      } else {
        // Si on a modifié la valeur de fin, l'update des filtres est déjà gérée
        this.updateTimeRangeFilter();
      }
    },
    selectedEndValue() {
      this.updateTimeRangeFilter();
    },
  },
  mounted: async function () {
    this.loadOptions();
    this.setDefaultValues(this.useDefaultValue);
  },

  methods: {
    loadOptions: function () {
      this.options = [];
      const offset = parseInt(process.env.VUE_APP_START_DAY);
      var i = 0;
      for (i = 0; i <= 24; i++) {
        var hour = (i + offset) % 24;
        this.options.push({
          filterValue: hour.toString(),
          hourAsInt: hour,
          label: numberFormat(hour, "timeRangePicker"),
          order: i,
        });
      }
    },
    setDefaultValues: function (useDefaultValue) {
      if (this.options && this.options.length) {
        const storedSelectedValues = Tools.StorageHelper.getStoredFilterSelectedValue(
          this.storageKey
        );
        if (storedSelectedValues && storedSelectedValues.length === 2) {
          this.selectedStartValue = this.options.find((o) =>
            this.isTimePickerValueEqual(o, storedSelectedValues[0])
          );
          this.selectedEndValue = this.options.find((o) =>
            this.isTimePickerValueEqual(o, storedSelectedValues[1])
          );
        }
        if (
          useDefaultValue &&
          (!this.selectedStartValue || !this.selectedEndValue)
        ) {
          this.selectedStartValue = this.options[0];
          this.selectedEndValue = this.options[this.options.length - 1];
        }
      }
    },
    updateTimeRangeFilter: function () {
      var self = this;
      if (self.selectedStartValue && self.selectedEndValue) {
        // Si la plage maximale est sélectionné, pas de filtre (optimisation des perfs)
        if (
          self.selectedStartValue.order === 0 &&
          self.selectedEndValue.order === 24
        ) {
          this.timeRangeFilter = null;
          this.isFullRange = true;
        } else {
          // NB : il faut lister les valeurs possibles au lieu d'utiliser des filtres >,< car cubeJs ne supporte pas encore bien le OR
          const possibleValues = self.options
            .filter((opt) => {
              if (
                self.selectedEndValue.hourAsInt <=
                self.selectedStartValue.hourAsInt
              )
                return (
                  opt.hourAsInt >= self.selectedStartValue.hourAsInt ||
                  opt.hourAsInt < self.selectedEndValue.hourAsInt
                );
              else
                return (
                  opt.hourAsInt >= self.selectedStartValue.hourAsInt &&
                  opt.hourAsInt < self.selectedEndValue.hourAsInt
                );
            })
            .map((opt) => opt.filterValue);
          this.timeRangeFilter = {
            dimension: dimensionEnum.TIME_HOUR,
            operator: "equals",
            values: possibleValues,
          };
          this.isFullRange = false;
        }
        Tools.StorageHelper.storeFilterSelectedValue(this.storageKey, [
          self.selectedStartValue,
          self.selectedEndValue,
        ]);
      } else {
        Tools.StorageHelper.storeFilterSelectedValue(this.storageKey, null);
        this.timeRangeFilter = null;
      }
      this.$emit("timeRangeFilterChanged", {
        timeRangeFilter: this.timeRangeFilter,
        isFullRange: this.isFullRange,
        startHour: self.selectedStartValue ? self.selectedStartValue.hourAsInt : null,
        endHour: self.selectedEndValue ? self.selectedEndValue.hourAsInt : null,
      });
    },
    isTimePickerValueEqual: function (timePickerValueA, timePickerValueB) {
      return (
        timePickerValueA &&
        timePickerValueB &&
        timePickerValueA.filterValue === timePickerValueB.filterValue &&
        timePickerValueA.hourAsInt === timePickerValueB.hourAsInt &&
        timePickerValueA.order === timePickerValueB.order
      );
    },
  },
};
</script>

<style>
.label-style {
  flex: 1;
  text-align: left;
  font-weight: bold;
}
</style>
